<template>
    <div class="popover popover-dark" @click="popper.close">
        <div class="popover-arrow is-left-bottom"></div>
        <div class="popover-control">
            <div class="popover-content popover-menu">
                <div class="popover-menu-item">
                    <user-avatar></user-avatar>
                </div>
            </div>
            <sandbox-menu-item/>
            <div class="popover-content popover-menu">
                <a target="_blank" href="https://help.rebilly.com/" class="popover-menu-item">
                    <v-icon icon="help" class="inline-s"/>
                    Rebilly Help Center</a>
                <!--<div class="popover-menu-item"><v-icon icon="info" class="inline-s" />API Status</div>-->
            </div>
            <div class="popover-content popover-menu">
                <a class="popover-menu-item" @click.prevent="$emit('logout')" href="#">
                    <v-icon icon="logout" class="inline-s"/>
                    Logout
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import {vIcon} from '@/components/form';
    import UserAvatar from '@/modules/layouts/components/user-avatar';
    import SandboxMenuItem from '@/modules/layouts/components/sandbox-menu-item';

    export default {
        components: {vIcon, UserAvatar, SandboxMenuItem},
        props: {
            popper: {
                type: Object,
                default: {close: () => {}},
            },
        },
    };
</script>
